const PATH = "/api/v1/crs";

const ENDPOINTS = {
    CRS: "/",
    CRS_ICON: "/icons/",
    CRS_DESTINATIONS: "/destinations/",
    CRS_INVENTORIES: "/inventories/",
    CRS_OPERATORS: "/operators/",
    CRS_SEED: "/seed/",
    CRS_PRICING_INVENTORY: "/pricing/inventory/",
    CRS_BOOKINGS: "/bookings/",
    CRS_SEARCH: "/search/",
    CRS_GALLERY_IMAGES: "/gallery-images/",
    CRS_GALLERY_VIDEOS: "/gallery-videos/",
    CRS_OPERATOR_ADDONS: "/operator-addons/",
    CRS_REVIEWS: "/reviews/",
    CRS_OFFERS: "/offers/",
    CRS_REGION: "/region/",
    CRS_COUPONS: "/coupons/",
    CRS_OPERATOR_CONTRACT: "/operator-contract/",
    CRS_OPERATOR_VENDOR: "/operator-vendor/",
    CRS_TAGS: "/tags/",
    CRS_TAG_ITEMS: "/tag-items/",
    CRS_OPERATOR_ADVANCES: "/operator-advances/",
    CRS_EXPERIENCES: "/experiences/",
    CRS_EXPERIENCE_DETAILS: "/experience-details/",
    CRS_EXPERIENCE_LINKS: "/experience-links/",
    CRS_EXPERIENCE_ITINERARY: "/experience-itinerary/",
    CRS_AMENITIES: "/amenities/",
    CRS_REPORTS: "/reports/",
    CRS_REPORTS_RATING: "/reports/rating/agg/",
    CRS_REPORTS_REVENUE: "/reports/revenue/agg/",
    CRS_REPORTS_CHECKIN: "/reports/booking/checkin/count/",
    CRS_REPORTS_NOSHOW: "/reports/booking/noshow/count/",
    CRS_REPORTS_CHECKOUT: "/reports/booking/checkout/count/",
    CRS_REPORTS_CANCELLATION: "/reports/booking/cancelled/count/",
    CRS_REPORTS_OCCUPANCY: "/reports/occupancy/agg",
    CRS_USER_RATING: "/user-rating/",
    CRS_OPERATOR_BOOKING_SOURCES: "/operator-booking-sources/",
    CRS_SCRAPE_SOURCES: "/scrape-sources/",
    CRS_REVIEW_PLATFORMS: "/review-platforms/",
    CRS_DESTINATION_OPERATORS: "/destination-operators/",
    CRS_INVETORY_SCHEDULES: "/inventory-schedules/",
    CRS_INVENTORY_TIMESLOTS: "/inventory-timeslots/",
    CRS_INVENTORY_AVAILABILITIES: "/inventory-availabilities/",
    CRS_AVAILABILITY_TIMESLOT: "/availability/time_slot/",
    CRS_PRICING_TIMESLOT: "/pricing/time_slot/",
    CRS_WALLETS: "/wallets/",
    CRS_WALLET_TRANSACTIONS: "/wallet-transactions/",
    CRS_COMPANIES: "/companies/",
    CRS_CHAT_CONTEXTS: "/chat/contexts/",
    CRS_LOCATIONS: "/locations/",
    CRS_SITE_META: "/site-meta/",
    CRS_DATA_FIELDS: "/datafields/",
    CRS_ZOBU_USERS: "/zobu-users/",
    CRS_ZOBU_TEAMS: "/zobu-teams/",
    CRS_ZOBU_TAGS: "/zobu-tags/",
    CRS_SUGGEST_EDITS_LIST: "/suggest-edits/",
    CRS_REPORTS_INSTAGRAM: "/reports/instagram/",
    CRS_DESTINATION_PINCODES: "/destination-pincodes/",
    CRS_EZEE: "/channel_manager/room_types/operator/",
    CRS_LEADS_QUESTIONS: "/leads/questions/",
    CRS_LEADS_GROUPS: "/leads/groups/",
    CRS_PLAYLISTS: "/playlists/",
    CRS_PLAYTRACKS: "/playtracks/",
    CRS_DISCOVER_CARDS: "/discover_cards/",
    CRS_JOBS: "/jobs/",
    CRS_BOOKING: "/booking/",
    CRS_WEB_CHECKIN: "/pms/checkins/",
    WEB_CHECKINS: "/checkins/",
    CRS_USER_BOOKINGS: "/user/bookings/",
    CRS_BLOG_POSTS: "/blog/posts/",
    CRS_BLOG_TAGS: "/blog/tags/",
    CRS_BLOG_IMAGES: "/blog/images/",
    CRS_CANCELLATION_POLICY: "/cancellation-policy/",
    CRS_BOOKING_CANCEL: "/booking/cancel/",
    CRS_BOOKING_CANCEL_INFO: "/booking/cancel/info/",
    CRS_DATA_FIELDS_UPLOAD_MEDIA: "/data-fields/upload-media/",
};

export type CRSEndpoints = keyof typeof ENDPOINTS;
export const CRSCollection = { PATH, ENDPOINTS };
